<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      {{ trans('schedule_sync_rules.actions.' + (isRelation ? 'relation' : 'simple'), { relation: field }) }}

      <i
        class="fa fa-times pull-right"
        style="cursor:pointer"
        @click="$emit('remove_action')"
      />
    </div>

    <div class="panel-body">
      <form class="form-horizontal">
        <!-- show the current field being edited-->
        <div class="form-group">
          <label
            class="control-label col-sm-2"
            for="name"
          > {{ trans('core.name') }} </label>
          <div class="col-sm-10">
            <input
              id="name"
              v-model="field"
              disabled="disabled"
              class="form-control"
            >
          </div>
        </div>

        <selector-component
          :id="'type-' + order"
          v-model="type"
          :label="trans('schedule_sync_rules.actions.type')"
          :options="types"
          :errormessage="errormessage.type"
          :disabled_message="disabledMessage"
        />

        <template v-if="isRelation">
          <selector-component
            :id="'sub_type-' + order"
            v-model="sub_type"
            :label="trans('schedule_sync_rules.actions.sub_type')"
            :options="sub_types"
            :errormessage="errormessage.sub_type"
            :disabled_message="disabledMessage"
          />

          <selector-component
            :id="'sub_field-' + order"
            v-model="sub_field"
            :label="trans('schedule_sync_rules.actions.sub_field')"
            :options="sub_fields"
            :errormessage="errormessage.sub_field"
            :disabled_message="disabledMessage"
          />
        </template>

        <input-component
          :id="'value-' + order"
          v-model="value"
          :label="trans('schedule_sync_rules.actions.value')"
          type="text"
          :errormessage="errormessage.value"
        />
      </form>
    </div>
  </div>
</template>

<script>
import InputComponent from '../FormComponents/InputComponent.vue'
import SelectorComponent from '../FormComponents/SelectorComponent.vue'

export default {
  components: {
    SelectorComponent,
    InputComponent,
  },
  props: {
    field: {
      required: true,
      type: String,
    },
    order: {
      required: true,
      type: Number,
    },
  },

  data () {
    return {
      sub_types: {
        append: this.trans('schedule_sync_rules.actions.append'),
        new: this.trans('schedule_sync_rules.actions.new'),
      },
      sub_fields: {
        name: this.trans('core.name'),
      },
    }
  },

  computed: {
    disabledMessage () {
      return this.trans('schedule_sync_rules.actions.disabled_message')
    },

    isRelation () {
      let relations = ['groups', 'lecturers', 'classrooms']

      return relations.includes(this.field)
    },
    /**
       * method that gives the possible options depending on whether the current action is based on a relation or not
       * @returns {*}
       */
    types () {
      if (this.isRelation) {
        return {
          replace: this.trans('schedule_sync_rules.actions.replace'),
          add: this.trans('schedule_sync_rules.actions.add'),
          remove: this.trans('schedule_sync_rules.actions.remove') }
      } else {
        return {
          append: this.trans('schedule_sync_rules.actions.append'),
          replace: this.trans('schedule_sync_rules.actions.replace'),
        }
      }
    },
    action () {
      return this.$store.state.scheduleSync.actions[this.order]
    },
    errormessage () {
      if (
        !(
          typeof this.$store.state.scheduleSync.action_errors[this.order] ===
            'undefined'
        )
      ) {
        return this.$store.state.scheduleSync.action_errors[this.order]
      } else {
        // otherwise we try to access a property of undefined array_index out of bounds
        return {}
      }
    },
    /**
       *  getters & setters for the possible values of the current actions
       */
    type: {
      get () {
        return this.action.type
      },

      set (value) {
        let index = this.order
        this.$store.dispatch('update_action', { index, name: 'type', value })
      },
    },
    value: {
      get () {
        return this.action.value
      },

      set (value) {
        let index = this.order
        this.$store.dispatch('update_action', { index, name: 'value', value })
      },
    },
    sub_type: {
      get () {
        return this.action.sub_type
      },

      set (value) {
        let index = this.order
        this.$store.dispatch('update_action', {
          index,
          name: 'sub_type',
          value,
        })
      },
    },
    sub_field: {
      get () {
        return this.action.sub_field
      },

      set (value) {
        let index = this.order
        this.$store.dispatch('update_action', {
          index,
          name: 'sub_field',
          value,
        })
      },
    },
  },
}
</script>
